import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IBoton } from 'modelos/src';

/** Lo que el diálogo necesita para poder decidir. Lo arma el padre (una sola vez). */
export interface DatosAgregarBotonServicio {
  /** Catálogo completo de botones (no filtrado por cliente: cualquier botón se puede usar). */
  botones: IBoton[];
  /** Ids que la sección "Servicios o Trámites" ya tiene (no se pueden volver a elegir). */
  yaUsados: string[];
}

/** Fila del listado, ya con lo que se muestra precalculado. */
interface FilaBoton {
  boton: IBoton;
  etiqueta: string;
  yaUsado: boolean;
}

/**
 * Buscar y elegir, por nombre, uno o varios botones existentes para sumar a la sección "Servicios
 * o Trámites" del cliente. No crea botones: solo selecciona ids del catálogo global ya cargado
 * (`botonesCatalogo`, sin pedir nada nuevo al backend). El orden final se arma después, con
 * drag&drop, en `servicios-tramites-seccion`.
 */
@Component({
  selector: 'app-agregar-boton-servicio-dialog',
  templateUrl: './agregar-boton-servicio-dialog.component.html',
  styleUrls: ['./agregar-boton-servicio-dialog.component.scss'],
  standalone: false,
})
export class AgregarBotonServicioDialogComponent {
  private dialogRef =
    inject<MatDialogRef<AgregarBotonServicioDialogComponent, string[]>>(
      MatDialogRef,
    );
  public data = inject<DatosAgregarBotonServicio>(MAT_DIALOG_DATA);

  public busqueda = '';
  /** Ids marcados en esta apertura del diálogo (todavía no confirmados). */
  public seleccionados = new Set<string>();

  private readonly filas: FilaBoton[] = this.armarFilas();

  private armarFilas(): FilaBoton[] {
    const yaUsados = new Set(this.data.yaUsados);
    return this.data.botones.map((boton) => ({
      boton,
      etiqueta: boton.variante
        ? `${boton.nombre} (${boton.variante})`
        : (boton.nombre ?? 'Sin nombre'),
      yaUsado: yaUsados.has(boton._id ?? ''),
    }));
  }

  get filasFiltradas(): FilaBoton[] {
    const t = this.busqueda.trim().toLowerCase();
    return this.filas.filter((f) => {
      if (f.yaUsado) return false;
      if (!t) return true;
      return f.etiqueta.toLowerCase().includes(t);
    });
  }

  public toggle(fila: FilaBoton): void {
    const id = fila.boton._id;
    if (!id) return;
    if (this.seleccionados.has(id)) {
      this.seleccionados.delete(id);
    } else {
      this.seleccionados.add(id);
    }
  }

  public agregar(): void {
    this.dialogRef.close([...this.seleccionados]);
  }

  public cerrar(): void {
    this.dialogRef.close();
  }
}
